import React from "react";
export function styledTooltipText(text) {
    return text.split("").map(function (char, index) {
        var isNumber = /\d/.test(char);
        var isSpace = char === " ";
        if (isSpace) {
            return (React.createElement("div", { key: index, className: "d-inline-block" }, "\u00A0"));
        }
        return (React.createElement("div", { key: index, className: "tooltip-content d-inline-block ".concat(isNumber ? "RobotoL_12_300" : "DMsanL_12_300") }, char));
    });
}
